var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import logo from "../../mixins/logo";
import { Badge, Icon, Tooltip } from "ant-design-vue-findsoft";
import getProductName from "../../mixins/productName";
import dayjs from "dayjs";
var MyIcon = Icon.createFromIconfontCN({
    scriptUrl: "/policy/static/fanalysis_icon_1845603/iconfont.js" // 在 iconfont.cn 上生成
});
export default Vue.extend({
    components: {
        aTooltip: Tooltip,
        aBadge: Badge,
        MyIcon: MyIcon,
        aIcon: Icon,
    },
    props: {
        NavList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        code: {
            type: String,
        },
    },
    data: function () {
        return {
            userInfo: {
                code: "",
                name: "",
                headImagePath: "",
                teacher: false,
                student: false,
                admin: false,
            },
            isShow: false,
            isNotice: false,
            isChange: false,
            firtUnReadNote: {},
        };
    },
    mixins: [logo, getProductName],
    methods: {
        openNote: function () {
            this.$store.dispatch("updataNotlist");
            this.isNotice = !this.isNotice;
        },
        gotoNotice: function () {
            if (this.isStudentPage) {
                this.$router.push("/Student/notice");
            }
            else {
                this.$router.push("/Teacher/notice");
            }
        },
        fun_switch: function () {
            // 切换窗口
            if (this.isStudentPage) {
                // 是学生页面就跳转到教师页面
                this.$router.push({
                    name: "userList",
                });
            }
            else {
                this.$router.push({
                    path: "/Student/home",
                });
            }
        },
        changePage: function (value) {
            this.$store.dispatch("updataNotlist");
            this.$router.push(this.NavList[value].path);
        },
        gotuPolicy: function () {
            if (this.casePower.includes("policy")) {
                if (this.isStudentPage) {
                    window.location.href = "/policy/#/Student/home";
                }
                else {
                    window.location.href = "/policy";
                }
            }
        },
        getByCode: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$store.dispatch("queryUserInfo", this.code)];
                        case 1:
                            _a.sent();
                            this.userInfo = this.$store.state.userInfor;
                            return [2 /*return*/];
                    }
                });
            });
        },
        loginOutCas: function () {
            //   router.replace('/pmcp/');
            window.open('./api/user/login/out/cas');
        },
        go: function (path) {
            var pathStr = "";
            if (path === "注销") {
                sessionStorage.clear();
                localStorage.clear();
                window.location.href = "/policy";
                if (sessionStorage.getItem('isCAS')) {
                    this.loginOutCas();
                    sessionStorage.removeItem('isCAS');
                }
            }
            else if (path === "个人中心") {
                if (this.$role.role == "student") {
                    pathStr = "/Student/personalCenter";
                }
                else {
                    pathStr = "/Teacher/personalCenter";
                }
                this.$router.push({
                    path: pathStr,
                });
            }
        },
        fun_go: function (x) { },
        intelligentNotification: function () {
            // const data = {
            //   pageNo: 1,
            //   pageSize: 99
            // };
            // this.$axios.intelligentNotification(data).then((res: any) => {
            //   if (res.data.success && res.data.data.list) {
            //     this.noteList = res.data.data.list;
            //     this.$store.commit("setNoteList", res.data.data.list);
            this.findFirstUnreadNotice(this.noteList);
            //   } else {
            //     this.noteList = [];
            //   }
            // });
        },
        findFirstUnreadNotice: function (list) {
            // 找到第一条没读的信息
            var find = function (val) {
                return val.isRead == 0;
            };
            if (list.find(find)) {
                this.firtUnReadNote = list.find(find);
            }
            else {
                this.firtUnReadNote = null;
            }
        },
        standardTime: function (v) {
            return dayjs(v).format("YYYY-MM-DD HH:mm:ss");
        }
    },
    computed: {
        casePowerState: function () {
            return this.casePower.includes("policy");
        },
        noteList: function () {
            return this.$store.getters.getNoteList;
        },
        casePower: function () {
            return this.$store.state.pattern;
        },
        isStudentPage: function () {
            return this.$router.history.current.path.includes("Student");
        },
    },
    watch: {
        noteList: function (old, newval) {
            this.findFirstUnreadNotice(this.noteList);
        },
    },
    created: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$store.dispatch("updataNotlist")];
                    case 1:
                        _a.sent();
                        this.intelligentNotification();
                        this.getByCode();
                        return [2 /*return*/];
                }
            });
        });
    },
});
